import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-779d3947"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "member",
  class: "form-view"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "wrap" }
const _hoisted_4 = { class: "vip-info" }
const _hoisted_5 = { class: "vip-status" }
const _hoisted_6 = {
  key: 0,
  class: "order-list"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "VIP订单获取记录", -1))
const _hoisted_8 = { cellspacing: "1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "交易类型"),
    /*#__PURE__*/_createElementVNode("th", null, "交易时间"),
    /*#__PURE__*/_createElementVNode("th", null, "会员时长")
  ])
], -1))
const _hoisted_10 = {
  key: 1,
  class: "privilege"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "您拥有的VIP特权", -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "list-wrap" }
const _hoisted_14 = { class: "compare" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "VIP权益详细对比", -1))

import {computed, defineAsyncComponent, ref} from 'vue';
import {useUser} from "@/composable/useUser";
import {vipConsumptionRecordApi, vipPrivilegeApi} from "@/api/member";

// 引入组件

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const MainTitle = defineAsyncComponent(() => import("@/views/member/components/MainTitle.vue"));
const VipCompare = defineAsyncComponent(() => import("@/components/vipCompare/index.vue"));

const {userInfo, handleShowText} = useUser();

/**
 * 是否是会员
 */
const isVip = computed(() => {
  return +userInfo.value.vip === 1;
})

/**
 * vip会员类型
 */
const vipType = computed(() => {
  return isVip.value ? '个人会员' : '未开通';
});

/**
 * vip会员开通状态
 */
const vipStatus = computed(() => {
  return isVip.value ? '您已开通': '您未开通';
});

/**
 * vip会员交易记录
 */
const vipTradeRecord = ref<any>([]);

/**
 * 获取vip消费记录
 */
const getVipTradeRecord = async () => {
  vipTradeRecord.value = await vipConsumptionRecordApi();
  console.log(vipTradeRecord.value);
}

getVipTradeRecord();

/**
 * vip会员特权
 */
const vipPrivilege = ref<any>([]);

/**
 * 获取vip会员特权
 */
const getVipPrivilege = async () => {
  vipPrivilege.value = await vipPrivilegeApi();
}
getVipPrivilege();

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MainTitle), null, {
      default: _withCtx(() => [
        _createTextVNode("会员中心")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "user-info",
        style: _normalizeStyle(`background-image: url(${require('@/assets/member/img/member/bg1.png')})`)
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, " VIP会员：" + _toDisplayString(_unref(handleShowText)(1).vipType), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(handleShowText)(1).timeText), 1),
            _createTextVNode("   "),
            _createVNode(_component_router_link, { to: "/member/join" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { class: "renewal" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(handleShowText)(1).vipText), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ], 4),
      (isVip.value || _unref(userInfo).yxtime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vipTradeRecord.value, (order) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: order.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(order.title), 1),
                    _createElementVNode("td", null, _toDisplayString(order.create_time), 1),
                    _createElementVNode("td", null, _toDisplayString(order.num), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (isVip.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vipPrivilege.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "list-item",
                    key: item.id
                  }, _toDisplayString(item.title), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_unref(VipCompare))
      ])
    ])
  ]))
}
}

})